export default class SelectionHandler {

  static NONE = 0;
  static SINGLE = 1;
  static MULTIPLE = 2;

  constructor(type = SelectionHandler.SINGLE) {
    this.type = type;
    this.selectionStart = this.selectionEnd = 0;
  }

  getSelection() {
    return {
      start: this.selectionStart,
      end: this.selectionEnd
    };
  }

  static hasSelection(items = []) {
    return !!items.find(item => item.selected);
  }

  static clearSelection(items = []) {
    const copy = [];

    for (let i = 0; i < items.length; i++) {
      if (items[i].selected) {
        const { selected, ...rest } = items[i]; // eslint-disable-line no-unused-vars

        copy.push(rest);
      } else {
        copy.push(items[i]);
      }
    }
    return copy;
  }

  static selectAll(items = []) {
    const copy = [];

    for (let i = 0; i < items.length; i++) {
      if (items[i].selected) {
        copy.push(items[i]);
      } else {
        copy.push({ ...items[i], selected: true });
      }
    }
    return copy;
  }

  getSelectedItems(items = [], index = -1, e = {}) {
    let selected = items;

    if (this.type !== SelectionHandler.NONE && index >= 0 && items.length > 0) {
      if (this.type === SelectionHandler.SINGLE || (!e.shiftKey && !e.ctrlKey && !e.metaKey)) {
        selected = SelectionHandler.clearSelection(selected);
        selected[index] = {
          ...selected[index],
          selected: true
        };
        this.selectionStart = this.selectionEnd = index;
      } else if (e.metaKey || e.ctrlKey) {
        selected = items.slice();
        selected[index] = {
          ...selected[index],
          selected: selected[index].selected ? undefined : true
        };
        this.selectionStart = this.selectionEnd = index;
      } else if (e.shiftKey) {
        const [min, max] = this.selectionStart > index ? [index, this.selectionStart] : [this.selectionStart, index];
        const [lastMin, lastMax] = this.selectionStart > this.selectionEnd ? [this.selectionEnd, this.selectionStart] : [this.selectionStart, this.selectionEnd];

        selected = items.map((item, idx) => {
          if ((idx < min || idx > max) && idx >= lastMin && idx <= lastMax && item.selected) {
            const { selected, ...rest } = item; // eslint-disable-line no-shadow, no-unused-vars

            return rest;
          } else if (idx >= min && idx <= max && !item.selected) {
            return {
              ...items[idx],
              selected: true
            };
          }
          return item;
        });
        this.selectionEnd = index;
      }
    }
    return selected;
  }

}
